// @flow

import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { path, range } from "ramda";
import {
  setSeletorAberto,
  getMedidasSelecionadas,
  getMedidasFixas,
  isMedidasSelecionadasEmEstadoInicial,
  trocarMedidaDePosicao,
  isAbrindoArquivo,
  getAtivoExcel,
  getMedidasSelecionadasDesabilitada,
  getModoApp,
} from "../../../state";
import {
  MODO_APP_SERIES,
  MODO_APP_NORMAL,
  MODO_APP_EXCEL,
} from "../../../model";

import { Translate } from "@quantum/i18n";
import { Spinner } from "@quantum/ui";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

import MedidasSelecionadasHeader from "../medidas-selecionadas-header";
import MedidaSelecionada from "../medida-selecionada";

// $FlowFixMe
import { ReactComponent as IconAdicionar } from "../../../assets/icone_adicionar_escuro.svg";

import "./medidas-selecionadas.css";
import { useFocusArea } from "../../focus-area";

export default function MedidasSelecionadas({
  renomeavel = true,
  semFechamentoDeMes = false,
  semDataBase = false,
}: *) {
  const dispatch = useDispatch();

  const abrindoArquivo = useSelector(isAbrindoArquivo);
  const desabilitado = useSelector(getMedidasSelecionadasDesabilitada);

  const medidasFixas = useSelector(getMedidasFixas);
  const todasAsMedidasSelecionadas = useSelector(getMedidasSelecionadas);

  const modo = useSelector(getModoApp);

  const medidasSelecionadas = todasAsMedidasSelecionadas.filter(
    ({ medida: { idConfiguracaoRelatorio } }) =>
      !medidasFixas
        .map(path(["medida", "idConfiguracaoRelatorio"]))
        .includes(idConfiguracaoRelatorio)
  );

  const medidas = abrindoArquivo ? [] : medidasSelecionadas;
  const linhasExtras = medidas.length === 0 ? range(0, 5) : [];

  const emEstadoInitial = useSelector(isMedidasSelecionadasEmEstadoInicial);

  const ativo = useSelector(getAtivoExcel);
  const focarInputAtivo = useFocusArea("inputAtivo");
  const focarInputBuscaGlobal = useFocusArea("inputBuscaGlobalResultados");

  const aoAdicionar = useCallback(() => {
    if (
      modo === MODO_APP_NORMAL ||
      modo === MODO_APP_SERIES ||
      (ativo.trim() !== "" && !MODO_APP_EXCEL)
    ) {
      dispatch(setSeletorAberto("buscaGlobal", true));
      focarInputBuscaGlobal();
    } else if (ativo.trim() !== "") {
      dispatch(setSeletorAberto("autoCompleteMedidas", true));
    } else {
      focarInputAtivo();
    }
  }, [ativo, modo, dispatch, focarInputAtivo, focarInputBuscaGlobal]);

  const aoArrastar = useCallback(
    ({ source, destination }) => {
      if (destination != null && source.index !== destination.index) {
        dispatch(trocarMedidaDePosicao(source.index, destination.index));
      }
    },
    [dispatch]
  );

  return (
    <div
      className={`MedidasSelecionadas ${
        desabilitado ? "MedidasSelecionadas--desabilitado" : ""
      }`}
    >
      {emEstadoInitial && !abrindoArquivo && (
        <div
          className="MedidasSelecionadas__adicionar-medidas"
          onClick={aoAdicionar}
        >
          <IconAdicionar />

          <div className="MedidasSelecionadas__adicionar-medidas-texto">
            {modo === "EXCEL" ? (
              "Insira um ativo e adicione uma medida para iniciar"
            ) : (
              <Translate>configuracaoRelatorio.adicioneUmaMedida</Translate>
            )}
          </div>
        </div>
      )}

      <MedidasSelecionadasHeader
        quantidadeMedidasSelecionadas={todasAsMedidasSelecionadas.length}
        semFechamentoDeMes={semFechamentoDeMes}
        semDataBase={semDataBase}
      />

      <DragDropContext onDragEnd={aoArrastar}>
        <Droppable droppableId="medidasSelecionadas">
          {droppable => (
            <div
              className="DroppableAreaMedidasSelecionadas"
              ref={droppable.innerRef}
              {...droppable.droppableProps}
            >
              {abrindoArquivo && <Spinner />}

              {!abrindoArquivo &&
                medidasFixas.map((medida, index) => (
                  <div className="MedidasSelecionadas__linha" key={index}>
                    <MedidaSelecionada
                      disabled
                      indice={0}
                      medidaSelecionada={medida}
                      renomeavel={renomeavel}
                    />
                  </div>
                ))}

              {medidas.map((medidaSelecionada, index) => (
                <Draggable
                  key={index + medidasFixas.length}
                  draggableId={String(index + medidasFixas.length)}
                  index={index + medidasFixas.length}
                >
                  {draggable => (
                    <div
                      className="MedidasSelecionadas__linha"
                      ref={draggable.innerRef}
                      {...draggable.draggableProps}
                      {...draggable.dragHandleProps}
                    >
                      <MedidaSelecionada
                        medidaSelecionada={medidaSelecionada}
                        indice={index + medidasFixas.length}
                        renomeavel={renomeavel}
                      />
                    </div>
                  )}
                </Draggable>
              ))}

              {droppable.placeholder}

              {linhasExtras.map(linha => (
                <div className="MedidasSelecionadas__linha" key={linha} />
              ))}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
}
